const mistakes = [
  'руководитель говорит слишком много и не даёт сотруднику высказаться;',
  'сразу давит должностью вместо аргументов и интересов;',
  'начинает оправдываться, теряя управленческую позицию;',
  'избегает сложного разговора до момента, когда он становится неизбежным;',
  'не формулирует конкретного результата, которого хочет добиться;',
  'обсуждает человека вместо поведения и результата;',
  'угрожает последствиями, которые не собирается реализовывать;',
  'соглашается на неопределённые договорённости без сроков и критериев;',
  'не фиксирует сроки и договорённости, полагаясь на память;',
  'возвращается к одной и той же проблеме несколько раз, не доводя до решения;',
  'пытается решить конфликт за счёт одной стороны;',
  'путает компромисс с отказом от своей позиции;',
  'превращает переговоры в спор о том, кто прав.',
];

export default function ManagerMistakes() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему управленческие переговоры не работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Типичные ошибки, из-за которых разговор не приводит к договорённости и результату
        </p>

        <div className="grid sm:grid-cols-2 gap-3">
          {mistakes.map((m, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{m}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}